import { Box } from "@mui/material";
import Changelog from "./Changelog"
import HelpCenter from "./HelpCenter"
import FAQ from "./FAQ"
import PublicAPI from "./PublicAPI"
import CONFIG from "utils/config";

export const PUBLIC_DOCS_COMPONENTS = {
  'faq': <FAQ />,
  'help-center': <HelpCenter />,
  'changelog': <Changelog />,
  'public-api': <PublicAPI />,
} as const;

type Props = {
  type: keyof typeof PUBLIC_DOCS_COMPONENTS;
}

const PublicDocs = ({ type }: Props) => {
  return (
    <Box width={"100%"} height={"100%"} sx={{
      background: "white",
      overflow: "hidden"
    }}>
      <iframe src={`${CONFIG.MANUAL_URL}/${type}/`} style={{
        width: "100%",
        height: "100%",
        border: "none",
        outline: "transparent"
      }} />
    </Box>
  );
}

export default PublicDocs;